import { render, staticRenderFns } from "./select-position.vue?vue&type=template&id=c849cb7a"
import script from "./select-position.ts?vue&type=script&lang=ts&external"
export * from "./select-position.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports